import { PressEvent } from '@react-types/shared';

import { StoreButton } from '@/components/ui/StoreButton';

import { Container, CtaButton, Header, InnerContainer, StoreButtonContainer } from './styles';

interface MainTextContentCtaColumnProps {
	title: string;
	isAppStoreButtonsVisible?: boolean;
	isAdditionalPaddingAboveCtaButton?: boolean;
	children: React.ReactNode;
	buttonProps?: {
		buttonText: string;
		buttonLink?: string;
		onPress?: (e: PressEvent) => void;
	};
	style?: React.CSSProperties;
}

const MainTextContentCtaColumn: React.FC<MainTextContentCtaColumnProps> = ({
	title,
	buttonProps,
	isAppStoreButtonsVisible = true,
	isAdditionalPaddingAboveCtaButton = false,
	children,
	style,
}) => {
	return (
		<Container style={style} data-testid="main-text-content-cta-column">
			<Header>{title}</Header>
			<InnerContainer>{children}</InnerContainer>
			{isAppStoreButtonsVisible && (
				<StoreButtonContainer>
					<StoreButton isSmall isDynamicWidth type="ios" />
					<StoreButton isSmall isDynamicWidth type="android" />
				</StoreButtonContainer>
			)}
			{buttonProps && (
				<CtaButton
					fullWidth
					backgroundColor="blue7"
					href={buttonProps.buttonLink}
					onPress={buttonProps.onPress}
					isAdditionalPaddingAboveCtaButton={isAdditionalPaddingAboveCtaButton}
				>
					{buttonProps.buttonText}
				</CtaButton>
			)}
		</Container>
	);
};

export default MainTextContentCtaColumn;
